export default "__VITE_ASSET__Vfzi86lD__"